// Import styles
import './styles/main.scss';

// Import components
import Modal from './components/modal/modal';
import Countdown from './components/countdown/countdown';

// Export individual components
export { Modal, Countdown };

// Create a default export with all utilities
const PageBlockUtils = {
    Modal,
    Countdown,
    version: '0.1.4'
};

export default PageBlockUtils;

// Auto-initialize if window exists (browser environment)
if (typeof window !== 'undefined') {
    window.PageBlockUtils = PageBlockUtils;
} 